import React from "react"
import { ADD } from "../../include/constant"
import ProductForm from "../common/ProductForm"
import AdminHeader from "./Header"

const AdminAddProduct = () => {
    return <AdminHeader >
        <div className="fixed-top-bar" style={{ backgroundColor: "#F1F4F9", padding: '30px', marginTop: "70px", marginBottom: "43px" }}>
            <ProductForm
                title="Add Product"
                type={ADD}
            />
        </div>
    </AdminHeader>
}

export default AdminAddProduct